import Layout from '@app-studio-web/ui/components/Layout'
import useUpdateMode from '@hooks/useUpdateMode'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'select-marathon'

export default function SelectMarathonQuestionPage() {
  const { t } = useTranslation()
  const submit = useSubmit()
  const { isUpdate, postToReactNative } = useUpdateMode()
  const events = [
    {
      name: '5k',
      level: t('pages.onboarding.selectMarathonQuestion.options.beginner'),
      title: t('pages.onboarding.selectMarathonQuestion.options.5k'),
      image: '/races/5k.png',
      value: '5k',
    },
    {
      name: '10k',
      level: t('pages.onboarding.selectMarathonQuestion.options.intermediate'),
      title: t('pages.onboarding.selectMarathonQuestion.options.10k'),
      image: '/races/10k.png',
      value: '10k',
    },
    {
      name: '21.1k',
      level: t('pages.onboarding.selectMarathonQuestion.options.intermediate'),
      title: t('pages.onboarding.selectMarathonQuestion.options.halfMarathon'),
      image: '/races/half-marathon.png',
      value: 'Half Marathon',
    },
    {
      name: 'Marathon',
      level: t('pages.onboarding.selectMarathonQuestion.options.advanced'),
      title: t('pages.onboarding.selectMarathonQuestion.options.fullMarathon'),
      image: '/races/marathon.png',
      value: 'Full Marathon',
    },
  ]

  const handleCardClick = (eventValue: string) => {
    const answer = {
      question_key: QUESTION_KEY,
      question: 'Which event would you like to train for?',
      answer_key: eventValue.toLowerCase(),
      answer: eventValue,
    }
    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      // Use FormData for consistency with other onboarding pages
      const formData = new FormData()
      formData.append('answer', eventValue)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <Layout>
      <div
        className="flex h-full flex-col items-center p-4 sm:p-6"
        style={{ justifyContent: 'center' }}
      >
        <div className="mb-6 text-center">
          <h1 className="custom-heading text-xl font-bold sm:text-2xl">
            {t('pages.onboarding.selectMarathonQuestion.heading')}
          </h1>
        </div>

        <div className="flex w-full flex-1 items-center justify-center">
          <div
            className="mx-auto grid grid-cols-2 gap-6"
            style={{ width: '396px' }}
          >
            {events.map((event) => (
              <div
                key={event.value}
                className="relative flex cursor-pointer items-stretch justify-start rounded-2xl bg-[#333] p-0 transition-transform hover:scale-105"
                style={{ maxWidth: '180px', maxHeight: '220px' }}
                onClick={() => handleCardClick(event.value)}
              >
                <div className="flex h-full w-full flex-col justify-start">
                  <div className="relative aspect-[4/3] w-full">
                    <img
                      src={event.image}
                      alt={event.title}
                      className="h-full w-full rounded-t-2xl bg-slate-500 object-cover"
                    />
                    <div className="absolute top-0 left-0 rounded-tl-lg rounded-br-lg rounded-bl-none bg-[#A3A3A3] px-2 py-1 text-xs font-medium text-white">
                      {event.level}
                    </div>
                  </div>
                  <div className="flex min-h-[40px] w-full flex-1 flex-col items-start justify-center rounded-b-2xl bg-white px-2 py-2 sm:px-3">
                    <div className="text-xs font-normal text-black">
                      {event.title}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}
